import styled from 'styled-components'

export const LoaderDiv = styled.div`
    position: relative;
    top: ${props => (props.signup ? '70px' : '40px')};
    right: ${props => props.signup && '250px'};
`
